import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AddVercelAuthInput = {
  businessId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};

export type AnalyticsView = {
  __typename?: 'AnalyticsView';
  configJson: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastRefreshedAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Branch = {
  __typename?: 'Branch';
  activeCommit: Commit;
  archived: Scalars['Boolean']['output'];
  author?: Maybe<User>;
  commits: Array<Commit>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
};

export type Business = {
  __typename?: 'Business';
  billedEventCurrentMonthUsage: Scalars['Float']['output'];
  billedRequestCurrentMonthUsage: Scalars['Float']['output'];
  billingDataJson?: Maybe<Scalars['String']['output']>;
  businessUsers: Array<BusinessUser>;
  defaultNewUserRole: BusinessUserRole;
  domains: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inviteToken?: Maybe<Scalars['String']['output']>;
  invites: Array<Invite>;
  invoices: Array<Invoice>;
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  plan: Plan;
  projects: Array<Project>;
  type: BusinessType;
  vercelAccountInformationJson?: Maybe<Scalars['String']['output']>;
  vercelConnectionsJson: Scalars['String']['output'];
  vercelEdgeConfigStores?: Maybe<Scalars['String']['output']>;
  vercelFlagsSecret?: Maybe<Scalars['String']['output']>;
};

export enum BusinessType {
  Business = 'Business',
  Personal = 'Personal'
}

export type BusinessUser = {
  __typename?: 'BusinessUser';
  id: Scalars['ID']['output'];
  isExtraAccount: Scalars['Boolean']['output'];
  role: BusinessUserRole;
  user: User;
};

export enum BusinessUserRole {
  Admin = 'Admin',
  Contributor = 'Contributor',
  Editor = 'Editor',
  Viewer = 'Viewer'
}

export type CloneProjectInput = {
  businessId: Scalars['ID']['input'];
  sourceCommitId?: InputMaybe<Scalars['String']['input']>;
  sourceProjectId: Scalars['ID']['input'];
};

export type ClosePullRequestInput = {
  pullRequestId: Scalars['ID']['input'];
};

export type Commit = {
  __typename?: 'Commit';
  author: User;
  configJson: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  implementation: Implementation;
  message: Scalars['String']['output'];
  parent?: Maybe<Commit>;
  project: Project;
  schema: Schema;
};

export type CommitSync = {
  __typename?: 'CommitSync';
  id: Scalars['ID']['output'];
  status: CommitSyncStatus;
  targetId: Scalars['String']['output'];
  type: CommitSyncType;
};

export enum CommitSyncStatus {
  Error = 'Error',
  Pending = 'Pending',
  Success = 'Success'
}

export enum CommitSyncType {
  Edge = 'Edge',
  Vercel = 'Vercel',
  Webhook = 'Webhook'
}

export type CreateAnalyticsViewInput = {
  configJson: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};

export type CreateBranchInput = {
  baseBranchName?: InputMaybe<Scalars['String']['input']>;
  baseCommitId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};

export type CreateBusinessInput = {
  domains: Array<Scalars['String']['input']>;
  inviteEmails: Array<Scalars['String']['input']>;
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  skipSwitch: Scalars['Boolean']['input'];
  transferProjectIds: Array<Scalars['ID']['input']>;
  upgradePlan?: InputMaybe<Plan>;
};

export type CreateBusinessResponse = {
  __typename?: 'CreateBusinessResponse';
  newBusinessId: Scalars['ID']['output'];
  upgradePlanUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateCommitInput = {
  branchName?: InputMaybe<Scalars['String']['input']>;
  eventTypesJson: Scalars['String']['input'];
  expressionJson: Scalars['String']['input'];
  message: Scalars['String']['input'];
  parentId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  rebaseBranchName?: InputMaybe<Scalars['String']['input']>;
  schemaCode: Scalars['String']['input'];
  splitsJson: Scalars['String']['input'];
};

export type CreateCommitResponse = {
  __typename?: 'CreateCommitResponse';
  newBranchName?: Maybe<Scalars['String']['output']>;
  newCommitId: Scalars['ID']['output'];
  newPullRequestId?: Maybe<Scalars['ID']['output']>;
  syncs: Array<CommitSync>;
};

export type CreateInvitesInput = {
  businessId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']>;
};

export type CreateProjectInput = {
  businessId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  templateName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProjectTokenInput = {
  projectId: Scalars['ID']['input'];
  scopes: Array<Scalars['String']['input']>;
  tokenName: Scalars['String']['input'];
};

export type CreatePullRequestCommentInput = {
  message: Scalars['String']['input'];
  pullRequestId: Scalars['ID']['input'];
  type: PullRequestCommentType;
};

export type CreatePullRequestInput = {
  fromBranchId: Scalars['ID']['input'];
  intoBranchId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

export type CreateVercelEdgeConfigStoreInput = {
  businessId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
};

export type CreateWebhookInput = {
  active: Scalars['Boolean']['input'];
  eventTypes: Array<WebhookEventType>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  secret: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type DeleteAnalyticsViewInput = {
  id: Scalars['ID']['input'];
};

export type DeleteProjectTokenInput = {
  projectId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export enum DimensionType {
  Continuous = 'Continuous',
  Discrete = 'Discrete'
}

export type EvaluationsJsonInput = {
  commitId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type EvictUserInput = {
  businessId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type FunnelDataJsonInput = {
  configJson: Scalars['String']['input'];
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
  viewId: Scalars['ID']['input'];
};

export type Implementation = {
  __typename?: 'Implementation';
  eventTypesJson: Scalars['String']['output'];
  expressionJson: Scalars['String']['output'];
  featuresJson: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  project: Project;
  splitsJson: Scalars['String']['output'];
};

export type Invite = {
  __typename?: 'Invite';
  business: Business;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sender: User;
};

export type Invoice = {
  __typename?: 'Invoice';
  end: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  start: Scalars['String']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type JoinBusinessInput = {
  businessId: Scalars['ID']['input'];
};

export type Log = {
  __typename?: 'Log';
  commitId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  level: LogLevel;
  message: Scalars['String']['output'];
  metadataJson: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  type: LogType;
};

export enum LogLevel {
  Debug = 'Debug',
  Error = 'Error',
  Info = 'Info',
  Warn = 'Warn'
}

export enum LogType {
  /** Codegen requests processed by the edge server */
  Codegen = 'Codegen',
  /** GraphQL requests processed by the edge server */
  GraphQl = 'GraphQL',
  /** Init requests processed by the edge server */
  Init = 'Init',
  /** JS requests processed by the edge server */
  Js = 'JS',
  /** Logs from the SDK, that doesn't relate to a specific node */
  SdkMessage = 'SDKMessage',
  /** Logs from the SDK, that relate to a specific node */
  SdkNode = 'SDKNode',
  /** Schema requests processed by the edge server */
  Schema = 'Schema'
}

export enum LogTypeDeprecated {
  Codegen = 'Codegen',
  GraphQl = 'GraphQL',
  Hash = 'Hash',
  Init = 'Init',
  Js = 'JS',
  Sdk = 'SDK',
  Schema = 'Schema'
}

export type LogsInput = {
  afterLogId?: InputMaybe<Scalars['ID']['input']>;
  beforeLogId?: InputMaybe<Scalars['ID']['input']>;
  commitId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type MergePullRequestInput = {
  pullRequestId: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addVercelAuth: Scalars['ID']['output'];
  cloneProject: Scalars['ID']['output'];
  closePullRequest: Scalars['ID']['output'];
  createAnalyticsView: Scalars['ID']['output'];
  createBranch: Scalars['ID']['output'];
  createBusiness: CreateBusinessResponse;
  createCommit: CreateCommitResponse;
  createInvites: Array<Scalars['ID']['output']>;
  createProject: Scalars['ID']['output'];
  createProjectToken: Scalars['String']['output'];
  createPullRequest: Scalars['ID']['output'];
  createPullRequestComment: Scalars['ID']['output'];
  createVercelEdgeConfigStore: Scalars['String']['output'];
  createWebhook: Scalars['ID']['output'];
  deleteAnalyticsView: Scalars['ID']['output'];
  deleteProjectToken: Scalars['String']['output'];
  evictUser: Scalars['ID']['output'];
  mergePullRequest: Scalars['ID']['output'];
  projectExportUrl: Scalars['String']['output'];
  rephraseText: RephraseTextResponse;
  reportCrash: Scalars['ID']['output'];
  revokeInvite: Scalars['ID']['output'];
  sendVerifyAndInviteEmail: Scalars['ID']['output'];
  updateAnalyticsView: Scalars['ID']['output'];
  updateBillingData: Scalars['ID']['output'];
  updateBranch: Scalars['ID']['output'];
  updateBusiness: Scalars['ID']['output'];
  updateBusinessUserRole: Scalars['ID']['output'];
  updateMe: Scalars['ID']['output'];
  updatePaymentMethod: UpdatePaymentMethodResponse;
  updatePlan: Scalars['ID']['output'];
  updateProject: Scalars['ID']['output'];
  updatePullRequestComment: Scalars['ID']['output'];
  updateWebhook: Scalars['ID']['output'];
  upgradePlan: UpgradePlanResponse;
  vercelSso: VercelSsoResponse;
  verifyEmailAndAcceptInvite: VerifyEmailAndAcceptInviteResponse;
};


export type MutationAddVercelAuthArgs = {
  input: AddVercelAuthInput;
};


export type MutationCloneProjectArgs = {
  input: CloneProjectInput;
};


export type MutationClosePullRequestArgs = {
  input: ClosePullRequestInput;
};


export type MutationCreateAnalyticsViewArgs = {
  input: CreateAnalyticsViewInput;
};


export type MutationCreateBranchArgs = {
  input: CreateBranchInput;
};


export type MutationCreateBusinessArgs = {
  input: CreateBusinessInput;
};


export type MutationCreateCommitArgs = {
  input: CreateCommitInput;
};


export type MutationCreateInvitesArgs = {
  input: CreateInvitesInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectTokenArgs = {
  input: CreateProjectTokenInput;
};


export type MutationCreatePullRequestArgs = {
  input: CreatePullRequestInput;
};


export type MutationCreatePullRequestCommentArgs = {
  input: CreatePullRequestCommentInput;
};


export type MutationCreateVercelEdgeConfigStoreArgs = {
  input: CreateVercelEdgeConfigStoreInput;
};


export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};


export type MutationDeleteAnalyticsViewArgs = {
  input: DeleteAnalyticsViewInput;
};


export type MutationDeleteProjectTokenArgs = {
  input: DeleteProjectTokenInput;
};


export type MutationEvictUserArgs = {
  input: EvictUserInput;
};


export type MutationMergePullRequestArgs = {
  input: MergePullRequestInput;
};


export type MutationProjectExportUrlArgs = {
  input: ProjectExportUrlInput;
};


export type MutationRephraseTextArgs = {
  input: RephraseTextInput;
};


export type MutationReportCrashArgs = {
  input: ReportCrashInput;
};


export type MutationRevokeInviteArgs = {
  input: RevokeInviteInput;
};


export type MutationSendVerifyAndInviteEmailArgs = {
  input: SendVerifyAndInviteEmailInput;
};


export type MutationUpdateAnalyticsViewArgs = {
  input: UpdateAnalyticsViewInput;
};


export type MutationUpdateBillingDataArgs = {
  input: UpdateBillingDataInput;
};


export type MutationUpdateBranchArgs = {
  input: UpdateBranchInput;
};


export type MutationUpdateBusinessArgs = {
  input: UpdateBusinessInput;
};


export type MutationUpdateBusinessUserRoleArgs = {
  input: UpdateBusinessUserRoleInput;
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInput;
};


export type MutationUpdatePaymentMethodArgs = {
  input: UpdatePaymentMethodInput;
};


export type MutationUpdatePlanArgs = {
  input: UpdatePlanInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdatePullRequestCommentArgs = {
  input: UpdatePullRequestCommentInput;
};


export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};


export type MutationUpgradePlanArgs = {
  input: UpgradePlanInput;
};


export type MutationVercelSsoArgs = {
  input: VercelSsoInput;
};


export type MutationVerifyEmailAndAcceptInviteArgs = {
  input: VerifyEmailAndAcceptInviteInput;
};

export enum Plan {
  Enterprise = 'enterprise',
  Free = 'free',
  Pro = 'pro',
  ProV2 = 'pro_v2',
  ProV3 = 'pro_v3',
  Starter = 'starter',
  StarterV2 = 'starter_v2'
}

export type PrimaryBusiness = {
  __typename?: 'PrimaryBusiness';
  business: Business;
  id: Scalars['ID']['output'];
  isExtraAccount: Scalars['Boolean']['output'];
  role: BusinessUserRole;
};

export type Project = {
  __typename?: 'Project';
  analyticsViews: Array<AnalyticsView>;
  branches: Array<Branch>;
  business: Business;
  defaultBranch: Branch;
  evaluatedFlags: Scalars['Boolean']['output'];
  generatedClient: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pullRequests: Array<PullRequest>;
  setupCompleted: Scalars['Boolean']['output'];
  showOnboarding: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  tokensJson: Scalars['String']['output'];
  webhooks: Array<Webhook>;
};

export type ProjectExportUrlInput = {
  fromCommitId: Scalars['Int']['input'];
  projectId: Scalars['ID']['input'];
  toCommitId: Scalars['Int']['input'];
};

export type ProjectUsage = {
  __typename?: 'ProjectUsage';
  occurredOn: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  values: Array<UsageValue>;
};

export type PullRequest = {
  __typename?: 'PullRequest';
  author: User;
  comments: Array<PullRequestComment>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  fromBranch: Branch;
  fromBranchCommit?: Maybe<Commit>;
  id: Scalars['ID']['output'];
  intoBranch: Branch;
  intoBranchCommit?: Maybe<Commit>;
  latestCommonCommit: Commit;
  project: Project;
  status: PullRequestStatus;
};

export type PullRequestComment = {
  __typename?: 'PullRequestComment';
  author: User;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  pullRequest: PullRequest;
  type: PullRequestCommentType;
};

export enum PullRequestCommentType {
  Approval = 'Approval',
  Comment = 'Comment'
}

export enum PullRequestStatus {
  Approved = 'Approved',
  Closed = 'Closed',
  Merged = 'Merged',
  Open = 'Open'
}

export type Query = {
  __typename?: 'Query';
  branch: Branch;
  businessUsage: Array<ProjectUsage>;
  businesses: Array<Business>;
  commit: Commit;
  commitSyncs: Array<CommitSync>;
  commits: Array<Commit>;
  evaluationsJson: Scalars['String']['output'];
  funnelDataJson: Scalars['String']['output'];
  logs: Array<Log>;
  me: User;
  primaryBusiness?: Maybe<PrimaryBusiness>;
  project: Project;
  projectBranch: Branch;
  pullRequest: PullRequest;
  tableDataJson: Scalars['String']['output'];
};


export type QueryBranchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBusinessUsageArgs = {
  input: UsageInput;
};


export type QueryCommitArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommitSyncsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommitsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryEvaluationsJsonArgs = {
  input: EvaluationsJsonInput;
};


export type QueryFunnelDataJsonArgs = {
  input: FunnelDataJsonInput;
};


export type QueryLogsArgs = {
  input: LogsInput;
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectBranchArgs = {
  branchName: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryPullRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTableDataJsonArgs = {
  input: TableDataJsonInput;
};

export enum RephraseAction {
  FixSpellingAndGrammar = 'FixSpellingAndGrammar',
  ImproveWriting = 'ImproveWriting',
  MakeLonger = 'MakeLonger',
  MakeShorter = 'MakeShorter'
}

export type RephraseTextInput = {
  action: RephraseAction;
  text: Scalars['String']['input'];
};

export type RephraseTextResponse = {
  __typename?: 'RephraseTextResponse';
  id?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type ReportCrashInput = {
  message: Scalars['String']['input'];
  stack?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeInviteInput = {
  id: Scalars['ID']['input'];
};

export type Schema = {
  __typename?: 'Schema';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  project: Project;
};

export type SendVerifyAndInviteEmailInput = {
  verifyEmailAndInviteToken?: InputMaybe<Scalars['String']['input']>;
};

export type TableDataJsonInput = {
  configJson: Scalars['String']['input'];
  end: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  start: Scalars['String']['input'];
  viewId: Scalars['ID']['input'];
};

export type UpdateAnalyticsViewInput = {
  configJson?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBillingDataInput = {
  billingDataJson: Scalars['ID']['input'];
  businessId: Scalars['ID']['input'];
};

export type UpdateBranchInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateBusinessInput = {
  defaultNewUserRole?: InputMaybe<BusinessUserRole>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  vercelConnectionsJson?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessUserRoleInput = {
  businessId: Scalars['ID']['input'];
  newRole: BusinessUserRole;
  userId: Scalars['ID']['input'];
};

export type UpdateMeInput = {
  metadataJson?: InputMaybe<Scalars['String']['input']>;
  primaryBusinessId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePaymentMethodInput = {
  businessId: Scalars['ID']['input'];
};

export type UpdatePaymentMethodResponse = {
  __typename?: 'UpdatePaymentMethodResponse';
  url: Scalars['String']['output'];
};

export type UpdatePlanInput = {
  businessId: Scalars['ID']['input'];
  cancel?: InputMaybe<Scalars['Boolean']['input']>;
  newPlan?: InputMaybe<Plan>;
};

export type UpdateProjectInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  businessId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePullRequestCommentInput = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export type UpdateWebhookInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<WebhookEventType>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradePlanInput = {
  businessId: Scalars['ID']['input'];
  plan: Plan;
};

export type UpgradePlanResponse = {
  __typename?: 'UpgradePlanResponse';
  url: Scalars['String']['output'];
};

export type UsageInput = {
  businessId: Scalars['ID']['input'];
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export enum UsageType {
  CodegenRequests = 'CodegenRequests',
  Events = 'Events',
  Exposures = 'Exposures',
  GraphQlRequests = 'GraphQLRequests',
  HashRequests = 'HashRequests',
  InitRequests = 'InitRequests',
  JsRequests = 'JSRequests',
  SchemaRequests = 'SchemaRequests'
}

export type UsageValue = {
  __typename?: 'UsageValue';
  type: UsageType;
  value: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  intercomToken: Scalars['String']['output'];
  isSharedAccount: Scalars['Boolean']['output'];
  metadataJson: Scalars['String']['output'];
};

export type VercelSsoInput = {
  code: Scalars['String']['input'];
};

export type VercelSsoResponse = {
  __typename?: 'VercelSsoResponse';
  firebaseCustomToken: Scalars['String']['output'];
};

export type VerifyEmailAndAcceptInviteInput = {
  businessInviteToken?: InputMaybe<Scalars['String']['input']>;
  verifyEmailAndInviteToken?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyEmailAndAcceptInviteResponse = {
  __typename?: 'VerifyEmailAndAcceptInviteResponse';
  joinedBusinessesCount: Scalars['Int']['output'];
  totalBusinessesCount: Scalars['Int']['output'];
  verifiedEmail: Scalars['Boolean']['output'];
};

export type Webhook = {
  __typename?: 'Webhook';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  eventTypes: Array<WebhookEventType>;
  id: Scalars['ID']['output'];
  lastFailedAt?: Maybe<Scalars['String']['output']>;
  lastSucceededAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  project: Project;
  secret: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum WebhookEventType {
  NewCommit = 'NEW_COMMIT'
}

export type ActiveCommitQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  branchName: Scalars['String']['input'];
}>;


export type ActiveCommitQuery = { __typename?: 'Query', projectBranch: { __typename?: 'Branch', activeCommit: { __typename?: 'Commit', id: string, configJson: string, schema: { __typename?: 'Schema', code: string }, implementation: { __typename?: 'Implementation', expressionJson: string, splitsJson: string, eventTypesJson: string, featuresJson: string } } } };

export type AddVercelAuthMutationVariables = Exact<{
  input: AddVercelAuthInput;
}>;


export type AddVercelAuthMutation = { __typename?: 'Mutation', addVercelAuth: string };

export type BusinessManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessManagementQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string }, primaryBusiness?: { __typename?: 'PrimaryBusiness', id: string, role: BusinessUserRole, business: { __typename?: 'Business', id: string, type: BusinessType, plan: Plan, inviteToken?: string | null, projects: Array<{ __typename?: 'Project', id: string }>, invites: Array<{ __typename?: 'Invite', id: string, email: string, createdAt: string, sender: { __typename?: 'User', id: string } }>, businessUsers: Array<{ __typename?: 'BusinessUser', id: string, role: BusinessUserRole, isExtraAccount: boolean, user: { __typename?: 'User', id: string, email: string, imageUrl: string, displayName: string, isSharedAccount: boolean } }> } } | null };

export type BusinessUsageQueryVariables = Exact<{
  input: UsageInput;
}>;


export type BusinessUsageQuery = { __typename?: 'Query', businessUsage: Array<{ __typename?: 'ProjectUsage', projectId: string, occurredOn: string, values: Array<{ __typename?: 'UsageValue', type: UsageType, value: number }> }> };

export type BusinessesQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, emailVerified: boolean, displayName: string, imageUrl: string, isSharedAccount: boolean }, primaryBusiness?: { __typename?: 'PrimaryBusiness', id: string, role: BusinessUserRole, isExtraAccount: boolean, business: { __typename?: 'Business', id: string, type: BusinessType, name: string, plan: Plan, billingDataJson?: string | null, domains: Array<string>, defaultNewUserRole: BusinessUserRole, vercelConnectionsJson: string, vercelFlagsSecret?: string | null, vercelAccountInformationJson?: string | null, businessUsers: Array<{ __typename?: 'BusinessUser', id: string, user: { __typename?: 'User', id: string, displayName: string } }>, projects: Array<{ __typename?: 'Project', id: string, name: string, tokensJson: string, defaultBranch: { __typename?: 'Branch', id: string, activeCommit: { __typename?: 'Commit', id: string, createdAt: string } } }>, invoices: Array<{ __typename?: 'Invoice', id: string, status: string, start: string, end: string, url: string, total: number }> } } | null, businesses: Array<{ __typename?: 'Business', id: string, type: BusinessType, name: string }> };

export type BusinessesLoginQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessesLoginQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, metadataJson: string }, primaryBusiness?: { __typename?: 'PrimaryBusiness', id: string, business: { __typename?: 'Business', id: string, projects: Array<{ __typename?: 'Project', id: string }> } } | null };

export type BusinessesManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessesManagementQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, emailVerified: boolean }, primaryBusiness?: { __typename?: 'PrimaryBusiness', id: string, business: { __typename?: 'Business', id: string, type: BusinessType } } | null, businesses: Array<{ __typename?: 'Business', id: string, type: BusinessType, name: string, memberCount: number }> };

export type CloneProjectMutationVariables = Exact<{
  input: CloneProjectInput;
}>;


export type CloneProjectMutation = { __typename?: 'Mutation', cloneProject: string };

export type ClosePullRequestMutationVariables = Exact<{
  input: ClosePullRequestInput;
}>;


export type ClosePullRequestMutation = { __typename?: 'Mutation', closePullRequest: string };

export type CommitQueryVariables = Exact<{
  commitId: Scalars['ID']['input'];
}>;


export type CommitQuery = { __typename?: 'Query', commit: { __typename?: 'Commit', id: string, configJson: string, message: string, createdAt: string, parent?: { __typename?: 'Commit', id: string, configJson: string, schema: { __typename?: 'Schema', id: string, code: string }, implementation: { __typename?: 'Implementation', id: string, expressionJson: string, splitsJson: string, eventTypesJson: string, featuresJson: string } } | null, schema: { __typename?: 'Schema', id: string, code: string }, implementation: { __typename?: 'Implementation', id: string, expressionJson: string, splitsJson: string, eventTypesJson: string, featuresJson: string }, author: { __typename?: 'User', id: string, displayName: string, email: string, imageUrl: string } } };

export type CommitSyncsQueryVariables = Exact<{
  commitId: Scalars['ID']['input'];
}>;


export type CommitSyncsQuery = { __typename?: 'Query', commitSyncs: Array<{ __typename?: 'CommitSync', id: string, type: CommitSyncType, status: CommitSyncStatus }> };

export type CreateAnalyticsViewMutationVariables = Exact<{
  input: CreateAnalyticsViewInput;
}>;


export type CreateAnalyticsViewMutation = { __typename?: 'Mutation', createAnalyticsView: string };

export type CreateBranchMutationVariables = Exact<{
  input: CreateBranchInput;
}>;


export type CreateBranchMutation = { __typename?: 'Mutation', createBranch: string };

export type CreateBusinessMutationVariables = Exact<{
  input: CreateBusinessInput;
}>;


export type CreateBusinessMutation = { __typename?: 'Mutation', createBusiness: { __typename?: 'CreateBusinessResponse', newBusinessId: string, upgradePlanUrl?: string | null } };

export type CreateCommitMutationVariables = Exact<{
  input: CreateCommitInput;
}>;


export type CreateCommitMutation = { __typename?: 'Mutation', createCommit: { __typename?: 'CreateCommitResponse', newCommitId: string, newPullRequestId?: string | null, newBranchName?: string | null, syncs: Array<{ __typename?: 'CommitSync', id: string, type: CommitSyncType, status: CommitSyncStatus }> } };

export type CreateInvitesMutationVariables = Exact<{
  input: CreateInvitesInput;
}>;


export type CreateInvitesMutation = { __typename?: 'Mutation', createInvites: Array<string> };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: string };

export type CreateProjectTokenMutationVariables = Exact<{
  input: CreateProjectTokenInput;
}>;


export type CreateProjectTokenMutation = { __typename?: 'Mutation', createProjectToken: string };

export type CreatePullRequestMutationVariables = Exact<{
  input: CreatePullRequestInput;
}>;


export type CreatePullRequestMutation = { __typename?: 'Mutation', createPullRequest: string };

export type CreatePullRequestCommentMutationVariables = Exact<{
  input: CreatePullRequestCommentInput;
}>;


export type CreatePullRequestCommentMutation = { __typename?: 'Mutation', createPullRequestComment: string };

export type CreateVercelEdgeConfigStoreMutationVariables = Exact<{
  input: CreateVercelEdgeConfigStoreInput;
}>;


export type CreateVercelEdgeConfigStoreMutation = { __typename?: 'Mutation', createVercelEdgeConfigStore: string };

export type CreateWebhookMutationVariables = Exact<{
  input: CreateWebhookInput;
}>;


export type CreateWebhookMutation = { __typename?: 'Mutation', createWebhook: string };

export type DeleteAnalyticsViewMutationVariables = Exact<{
  input: DeleteAnalyticsViewInput;
}>;


export type DeleteAnalyticsViewMutation = { __typename?: 'Mutation', deleteAnalyticsView: string };

export type DeleteProjectTokenMutationVariables = Exact<{
  input: DeleteProjectTokenInput;
}>;


export type DeleteProjectTokenMutation = { __typename?: 'Mutation', deleteProjectToken: string };

export type EvaluationsQueryVariables = Exact<{
  input: EvaluationsJsonInput;
}>;


export type EvaluationsQuery = { __typename?: 'Query', evaluationsJson: string };

export type EvictUserMutationVariables = Exact<{
  input: EvictUserInput;
}>;


export type EvictUserMutation = { __typename?: 'Mutation', evictUser: string };

export type FunnelDataQueryVariables = Exact<{
  input: FunnelDataJsonInput;
}>;


export type FunnelDataQuery = { __typename?: 'Query', funnelDataJson: string };

export type LogsQueryVariables = Exact<{
  input: LogsInput;
}>;


export type LogsQuery = { __typename?: 'Query', logs: Array<{ __typename?: 'Log', id: string, type: LogType, level: LogLevel, message: string, createdAt: string, metadataJson: string, commitId?: string | null }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, emailVerified: boolean, displayName: string, intercomToken: string, metadataJson: string }, primaryBusiness?: { __typename?: 'PrimaryBusiness', id: string, business: { __typename?: 'Business', id: string, type: BusinessType, plan: Plan } } | null };

export type MergePullRequestMutationVariables = Exact<{
  input: MergePullRequestInput;
}>;


export type MergePullRequestMutation = { __typename?: 'Mutation', mergePullRequest: string };

export type PrimaryBusinessUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type PrimaryBusinessUsageQuery = { __typename?: 'Query', primaryBusiness?: { __typename?: 'PrimaryBusiness', id: string, business: { __typename?: 'Business', id: string, plan: Plan, memberCount: number, billedRequestCurrentMonthUsage: number, billedEventCurrentMonthUsage: number } } | null };

export type ProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, displayName: string, imageUrl: string }, primaryBusiness?: { __typename?: 'PrimaryBusiness', id: string, role: BusinessUserRole } | null, project: { __typename?: 'Project', id: string, name: string, tokensJson: string, showOnboarding: boolean, setupCompleted: boolean, business: { __typename?: 'Business', id: string, name: string, type: BusinessType }, branches: Array<{ __typename?: 'Branch', id: string, name: string, createdAt: string, activeCommit: { __typename?: 'Commit', id: string }, author?: { __typename?: 'User', id: string } | null }>, pullRequests: Array<{ __typename?: 'PullRequest', id: string, status: PullRequestStatus, createdAt: string, intoBranch: { __typename?: 'Branch', id: string, name: string }, fromBranch: { __typename?: 'Branch', id: string, name: string }, author: { __typename?: 'User', id: string, displayName: string, imageUrl: string } }>, analyticsViews: Array<{ __typename?: 'AnalyticsView', id: string, name: string, configJson: string }>, webhooks: Array<{ __typename?: 'Webhook', id: string, name: string, url: string, eventTypes: Array<WebhookEventType>, secret: string, active: boolean, createdAt: string }> } };

export type ProjectAnalyticsViewsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectAnalyticsViewsQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, analyticsViews: Array<{ __typename?: 'AnalyticsView', id: string, name: string, configJson: string, lastRefreshedAt: string }> } };

export type ProjectBranchQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  branchName: Scalars['String']['input'];
}>;


export type ProjectBranchQuery = { __typename?: 'Query', projectBranch: { __typename?: 'Branch', id: string, name: string, author?: { __typename?: 'User', id: string } | null, activeCommit: { __typename?: 'Commit', id: string, configJson: string, schema: { __typename?: 'Schema', code: string }, implementation: { __typename?: 'Implementation', expressionJson: string, splitsJson: string, eventTypesJson: string, featuresJson: string } }, commits: Array<{ __typename?: 'Commit', id: string, message: string, createdAt: string, author: { __typename?: 'User', id: string, displayName: string, email: string, imageUrl: string } }> } };

export type ProjectExportUrlMutationVariables = Exact<{
  input: ProjectExportUrlInput;
}>;


export type ProjectExportUrlMutation = { __typename?: 'Mutation', projectExportUrl: string };

export type ProjectSetupQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectSetupQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, showOnboarding: boolean, setupCompleted: boolean, generatedClient: boolean, evaluatedFlags: boolean } };

export type PullRequestQueryVariables = Exact<{
  pullRequestId: Scalars['ID']['input'];
}>;


export type PullRequestQuery = { __typename?: 'Query', pullRequest: { __typename?: 'PullRequest', id: string, status: PullRequestStatus, createdAt: string, intoBranch: { __typename?: 'Branch', id: string, name: string, activeCommit: { __typename?: 'Commit', id: string, configJson: string, schema: { __typename?: 'Schema', id: string, code: string }, implementation: { __typename?: 'Implementation', id: string, expressionJson: string, splitsJson: string, eventTypesJson: string, featuresJson: string } }, commits: Array<{ __typename?: 'Commit', id: string }> }, fromBranch: { __typename?: 'Branch', id: string, name: string, archived: boolean, author?: { __typename?: 'User', id: string } | null, activeCommit: { __typename?: 'Commit', id: string, configJson: string, parent?: { __typename?: 'Commit', id: string } | null, schema: { __typename?: 'Schema', id: string, code: string }, implementation: { __typename?: 'Implementation', id: string, expressionJson: string, splitsJson: string, eventTypesJson: string, featuresJson: string } } }, intoBranchCommit?: { __typename?: 'Commit', id: string, configJson: string, schema: { __typename?: 'Schema', id: string, code: string }, implementation: { __typename?: 'Implementation', id: string, expressionJson: string, splitsJson: string, eventTypesJson: string, featuresJson: string } } | null, fromBranchCommit?: { __typename?: 'Commit', id: string, configJson: string, schema: { __typename?: 'Schema', id: string, code: string }, implementation: { __typename?: 'Implementation', id: string, expressionJson: string, splitsJson: string, eventTypesJson: string, featuresJson: string } } | null, latestCommonCommit: { __typename?: 'Commit', id: string, configJson: string, parent?: { __typename?: 'Commit', id: string } | null, schema: { __typename?: 'Schema', id: string, code: string }, implementation: { __typename?: 'Implementation', id: string, expressionJson: string, splitsJson: string, eventTypesJson: string, featuresJson: string } }, author: { __typename?: 'User', id: string, displayName: string, imageUrl: string }, comments: Array<{ __typename?: 'PullRequestComment', id: string, type: PullRequestCommentType, message: string, createdAt: string, author: { __typename?: 'User', id: string, displayName: string, imageUrl: string } }> } };

export type RephraseTextMutationVariables = Exact<{
  input: RephraseTextInput;
}>;


export type RephraseTextMutation = { __typename?: 'Mutation', rephraseText: { __typename?: 'RephraseTextResponse', id?: string | null, text: string } };

export type ReportCrashMutationVariables = Exact<{
  input: ReportCrashInput;
}>;


export type ReportCrashMutation = { __typename?: 'Mutation', reportCrash: string };

export type RevokeInviteMutationVariables = Exact<{
  input: RevokeInviteInput;
}>;


export type RevokeInviteMutation = { __typename?: 'Mutation', revokeInvite: string };

export type SendVerifyAndInviteEmailMutationVariables = Exact<{
  input: SendVerifyAndInviteEmailInput;
}>;


export type SendVerifyAndInviteEmailMutation = { __typename?: 'Mutation', sendVerifyAndInviteEmail: string };

export type TableDataQueryVariables = Exact<{
  input: TableDataJsonInput;
}>;


export type TableDataQuery = { __typename?: 'Query', tableDataJson: string };

export type UpdateAnalyticsViewMutationVariables = Exact<{
  input: UpdateAnalyticsViewInput;
}>;


export type UpdateAnalyticsViewMutation = { __typename?: 'Mutation', updateAnalyticsView: string };

export type UpdateBillingDataMutationVariables = Exact<{
  input: UpdateBillingDataInput;
}>;


export type UpdateBillingDataMutation = { __typename?: 'Mutation', updateBillingData: string };

export type UpdateBranchMutationVariables = Exact<{
  input: UpdateBranchInput;
}>;


export type UpdateBranchMutation = { __typename?: 'Mutation', updateBranch: string };

export type UpdateBusinessMutationVariables = Exact<{
  input: UpdateBusinessInput;
}>;


export type UpdateBusinessMutation = { __typename?: 'Mutation', updateBusiness: string };

export type UpdateBusinessUserRoleMutationVariables = Exact<{
  input: UpdateBusinessUserRoleInput;
}>;


export type UpdateBusinessUserRoleMutation = { __typename?: 'Mutation', updateBusinessUserRole: string };

export type UpdateMeMutationVariables = Exact<{
  input: UpdateMeInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe: string };

export type UpdatePaymentMethodMutationVariables = Exact<{
  input: UpdatePaymentMethodInput;
}>;


export type UpdatePaymentMethodMutation = { __typename?: 'Mutation', updatePaymentMethod: { __typename?: 'UpdatePaymentMethodResponse', url: string } };

export type UpdatePlanMutationVariables = Exact<{
  input: UpdatePlanInput;
}>;


export type UpdatePlanMutation = { __typename?: 'Mutation', updatePlan: string };

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: string };

export type UpdatePullRequestCommentMutationVariables = Exact<{
  input: UpdatePullRequestCommentInput;
}>;


export type UpdatePullRequestCommentMutation = { __typename?: 'Mutation', updatePullRequestComment: string };

export type UpdateWebhookMutationVariables = Exact<{
  input: UpdateWebhookInput;
}>;


export type UpdateWebhookMutation = { __typename?: 'Mutation', updateWebhook: string };

export type UpgradePlanMutationVariables = Exact<{
  input: UpgradePlanInput;
}>;


export type UpgradePlanMutation = { __typename?: 'Mutation', upgradePlan: { __typename?: 'UpgradePlanResponse', url: string } };

export type VercelEdgeConfigStoresQueryVariables = Exact<{ [key: string]: never; }>;


export type VercelEdgeConfigStoresQuery = { __typename?: 'Query', primaryBusiness?: { __typename?: 'PrimaryBusiness', id: string, business: { __typename?: 'Business', id: string, vercelEdgeConfigStores?: string | null } } | null };

export type VercelSsoMutationVariables = Exact<{
  input: VercelSsoInput;
}>;


export type VercelSsoMutation = { __typename?: 'Mutation', vercelSso: { __typename?: 'VercelSsoResponse', firebaseCustomToken: string } };

export type VerifyEmailAndAcceptInviteMutationVariables = Exact<{
  input: VerifyEmailAndAcceptInviteInput;
}>;


export type VerifyEmailAndAcceptInviteMutation = { __typename?: 'Mutation', verifyEmailAndAcceptInvite: { __typename?: 'VerifyEmailAndAcceptInviteResponse', verifiedEmail: boolean, totalBusinessesCount: number } };


export const ActiveCommitDocument = gql`
    query ActiveCommit($projectId: ID!, $branchName: String!) {
  projectBranch(projectId: $projectId, branchName: $branchName) {
    activeCommit {
      id
      schema {
        code
      }
      implementation {
        expressionJson
        splitsJson
        eventTypesJson
        featuresJson
      }
      configJson
    }
  }
}
    `;

/**
 * __useActiveCommitQuery__
 *
 * To run a query within a React component, call `useActiveCommitQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCommitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCommitQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      branchName: // value for 'branchName'
 *   },
 * });
 */
export function useActiveCommitQuery(baseOptions: Apollo.QueryHookOptions<ActiveCommitQuery, ActiveCommitQueryVariables> & ({ variables: ActiveCommitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveCommitQuery, ActiveCommitQueryVariables>(ActiveCommitDocument, options);
      }
export function useActiveCommitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveCommitQuery, ActiveCommitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveCommitQuery, ActiveCommitQueryVariables>(ActiveCommitDocument, options);
        }
export function useActiveCommitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveCommitQuery, ActiveCommitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveCommitQuery, ActiveCommitQueryVariables>(ActiveCommitDocument, options);
        }
export type ActiveCommitQueryHookResult = ReturnType<typeof useActiveCommitQuery>;
export type ActiveCommitLazyQueryHookResult = ReturnType<typeof useActiveCommitLazyQuery>;
export type ActiveCommitSuspenseQueryHookResult = ReturnType<typeof useActiveCommitSuspenseQuery>;
export type ActiveCommitQueryResult = Apollo.QueryResult<ActiveCommitQuery, ActiveCommitQueryVariables>;
export const AddVercelAuthDocument = gql`
    mutation AddVercelAuth($input: AddVercelAuthInput!) {
  addVercelAuth(input: $input)
}
    `;
export type AddVercelAuthMutationFn = Apollo.MutationFunction<AddVercelAuthMutation, AddVercelAuthMutationVariables>;

/**
 * __useAddVercelAuthMutation__
 *
 * To run a mutation, you first call `useAddVercelAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVercelAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVercelAuthMutation, { data, loading, error }] = useAddVercelAuthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVercelAuthMutation(baseOptions?: Apollo.MutationHookOptions<AddVercelAuthMutation, AddVercelAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVercelAuthMutation, AddVercelAuthMutationVariables>(AddVercelAuthDocument, options);
      }
export type AddVercelAuthMutationHookResult = ReturnType<typeof useAddVercelAuthMutation>;
export type AddVercelAuthMutationResult = Apollo.MutationResult<AddVercelAuthMutation>;
export type AddVercelAuthMutationOptions = Apollo.BaseMutationOptions<AddVercelAuthMutation, AddVercelAuthMutationVariables>;
export const BusinessManagementDocument = gql`
    query BusinessManagement {
  me {
    id
  }
  primaryBusiness {
    id
    role
    business {
      id
      type
      plan
      inviteToken
      projects {
        id
      }
      invites {
        id
        sender {
          id
        }
        email
        createdAt
      }
      businessUsers {
        id
        role
        isExtraAccount
        user {
          id
          email
          imageUrl
          displayName
          isSharedAccount
        }
      }
    }
  }
}
    `;

/**
 * __useBusinessManagementQuery__
 *
 * To run a query within a React component, call `useBusinessManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessManagementQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessManagementQuery(baseOptions?: Apollo.QueryHookOptions<BusinessManagementQuery, BusinessManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessManagementQuery, BusinessManagementQueryVariables>(BusinessManagementDocument, options);
      }
export function useBusinessManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessManagementQuery, BusinessManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessManagementQuery, BusinessManagementQueryVariables>(BusinessManagementDocument, options);
        }
export function useBusinessManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessManagementQuery, BusinessManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessManagementQuery, BusinessManagementQueryVariables>(BusinessManagementDocument, options);
        }
export type BusinessManagementQueryHookResult = ReturnType<typeof useBusinessManagementQuery>;
export type BusinessManagementLazyQueryHookResult = ReturnType<typeof useBusinessManagementLazyQuery>;
export type BusinessManagementSuspenseQueryHookResult = ReturnType<typeof useBusinessManagementSuspenseQuery>;
export type BusinessManagementQueryResult = Apollo.QueryResult<BusinessManagementQuery, BusinessManagementQueryVariables>;
export const BusinessUsageDocument = gql`
    query BusinessUsage($input: UsageInput!) {
  businessUsage(input: $input) {
    projectId
    occurredOn
    values {
      type
      value
    }
  }
}
    `;

/**
 * __useBusinessUsageQuery__
 *
 * To run a query within a React component, call `useBusinessUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessUsageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessUsageQuery(baseOptions: Apollo.QueryHookOptions<BusinessUsageQuery, BusinessUsageQueryVariables> & ({ variables: BusinessUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessUsageQuery, BusinessUsageQueryVariables>(BusinessUsageDocument, options);
      }
export function useBusinessUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessUsageQuery, BusinessUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessUsageQuery, BusinessUsageQueryVariables>(BusinessUsageDocument, options);
        }
export function useBusinessUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessUsageQuery, BusinessUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessUsageQuery, BusinessUsageQueryVariables>(BusinessUsageDocument, options);
        }
export type BusinessUsageQueryHookResult = ReturnType<typeof useBusinessUsageQuery>;
export type BusinessUsageLazyQueryHookResult = ReturnType<typeof useBusinessUsageLazyQuery>;
export type BusinessUsageSuspenseQueryHookResult = ReturnType<typeof useBusinessUsageSuspenseQuery>;
export type BusinessUsageQueryResult = Apollo.QueryResult<BusinessUsageQuery, BusinessUsageQueryVariables>;
export const BusinessesDocument = gql`
    query Businesses {
  me {
    id
    email
    emailVerified
    displayName
    imageUrl
    isSharedAccount
  }
  primaryBusiness {
    id
    role
    isExtraAccount
    business {
      id
      type
      name
      plan
      billingDataJson
      domains
      defaultNewUserRole
      businessUsers {
        id
        user {
          id
          displayName
        }
      }
      projects {
        id
        name
        tokensJson
        defaultBranch {
          id
          activeCommit {
            id
            createdAt
          }
        }
      }
      invoices {
        id
        status
        start
        end
        url
        total
      }
      vercelConnectionsJson
      vercelFlagsSecret
      vercelAccountInformationJson
    }
  }
  businesses {
    id
    type
    name
  }
}
    `;

/**
 * __useBusinessesQuery__
 *
 * To run a query within a React component, call `useBusinessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessesQuery(baseOptions?: Apollo.QueryHookOptions<BusinessesQuery, BusinessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessesQuery, BusinessesQueryVariables>(BusinessesDocument, options);
      }
export function useBusinessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessesQuery, BusinessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessesQuery, BusinessesQueryVariables>(BusinessesDocument, options);
        }
export function useBusinessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessesQuery, BusinessesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessesQuery, BusinessesQueryVariables>(BusinessesDocument, options);
        }
export type BusinessesQueryHookResult = ReturnType<typeof useBusinessesQuery>;
export type BusinessesLazyQueryHookResult = ReturnType<typeof useBusinessesLazyQuery>;
export type BusinessesSuspenseQueryHookResult = ReturnType<typeof useBusinessesSuspenseQuery>;
export type BusinessesQueryResult = Apollo.QueryResult<BusinessesQuery, BusinessesQueryVariables>;
export const BusinessesLoginDocument = gql`
    query BusinessesLogin {
  me {
    id
    metadataJson
  }
  primaryBusiness {
    id
    business {
      id
      projects {
        id
      }
    }
  }
}
    `;

/**
 * __useBusinessesLoginQuery__
 *
 * To run a query within a React component, call `useBusinessesLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessesLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessesLoginQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessesLoginQuery(baseOptions?: Apollo.QueryHookOptions<BusinessesLoginQuery, BusinessesLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessesLoginQuery, BusinessesLoginQueryVariables>(BusinessesLoginDocument, options);
      }
export function useBusinessesLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessesLoginQuery, BusinessesLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessesLoginQuery, BusinessesLoginQueryVariables>(BusinessesLoginDocument, options);
        }
export function useBusinessesLoginSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessesLoginQuery, BusinessesLoginQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessesLoginQuery, BusinessesLoginQueryVariables>(BusinessesLoginDocument, options);
        }
export type BusinessesLoginQueryHookResult = ReturnType<typeof useBusinessesLoginQuery>;
export type BusinessesLoginLazyQueryHookResult = ReturnType<typeof useBusinessesLoginLazyQuery>;
export type BusinessesLoginSuspenseQueryHookResult = ReturnType<typeof useBusinessesLoginSuspenseQuery>;
export type BusinessesLoginQueryResult = Apollo.QueryResult<BusinessesLoginQuery, BusinessesLoginQueryVariables>;
export const BusinessesManagementDocument = gql`
    query BusinessesManagement {
  me {
    id
    email
    emailVerified
  }
  primaryBusiness {
    id
    business {
      id
      type
    }
  }
  businesses {
    id
    type
    name
    memberCount
  }
}
    `;

/**
 * __useBusinessesManagementQuery__
 *
 * To run a query within a React component, call `useBusinessesManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessesManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessesManagementQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessesManagementQuery(baseOptions?: Apollo.QueryHookOptions<BusinessesManagementQuery, BusinessesManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessesManagementQuery, BusinessesManagementQueryVariables>(BusinessesManagementDocument, options);
      }
export function useBusinessesManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessesManagementQuery, BusinessesManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessesManagementQuery, BusinessesManagementQueryVariables>(BusinessesManagementDocument, options);
        }
export function useBusinessesManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessesManagementQuery, BusinessesManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessesManagementQuery, BusinessesManagementQueryVariables>(BusinessesManagementDocument, options);
        }
export type BusinessesManagementQueryHookResult = ReturnType<typeof useBusinessesManagementQuery>;
export type BusinessesManagementLazyQueryHookResult = ReturnType<typeof useBusinessesManagementLazyQuery>;
export type BusinessesManagementSuspenseQueryHookResult = ReturnType<typeof useBusinessesManagementSuspenseQuery>;
export type BusinessesManagementQueryResult = Apollo.QueryResult<BusinessesManagementQuery, BusinessesManagementQueryVariables>;
export const CloneProjectDocument = gql`
    mutation CloneProject($input: CloneProjectInput!) {
  cloneProject(input: $input)
}
    `;
export type CloneProjectMutationFn = Apollo.MutationFunction<CloneProjectMutation, CloneProjectMutationVariables>;

/**
 * __useCloneProjectMutation__
 *
 * To run a mutation, you first call `useCloneProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProjectMutation, { data, loading, error }] = useCloneProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneProjectMutation(baseOptions?: Apollo.MutationHookOptions<CloneProjectMutation, CloneProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneProjectMutation, CloneProjectMutationVariables>(CloneProjectDocument, options);
      }
export type CloneProjectMutationHookResult = ReturnType<typeof useCloneProjectMutation>;
export type CloneProjectMutationResult = Apollo.MutationResult<CloneProjectMutation>;
export type CloneProjectMutationOptions = Apollo.BaseMutationOptions<CloneProjectMutation, CloneProjectMutationVariables>;
export const ClosePullRequestDocument = gql`
    mutation ClosePullRequest($input: ClosePullRequestInput!) {
  closePullRequest(input: $input)
}
    `;
export type ClosePullRequestMutationFn = Apollo.MutationFunction<ClosePullRequestMutation, ClosePullRequestMutationVariables>;

/**
 * __useClosePullRequestMutation__
 *
 * To run a mutation, you first call `useClosePullRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClosePullRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closePullRequestMutation, { data, loading, error }] = useClosePullRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClosePullRequestMutation(baseOptions?: Apollo.MutationHookOptions<ClosePullRequestMutation, ClosePullRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClosePullRequestMutation, ClosePullRequestMutationVariables>(ClosePullRequestDocument, options);
      }
export type ClosePullRequestMutationHookResult = ReturnType<typeof useClosePullRequestMutation>;
export type ClosePullRequestMutationResult = Apollo.MutationResult<ClosePullRequestMutation>;
export type ClosePullRequestMutationOptions = Apollo.BaseMutationOptions<ClosePullRequestMutation, ClosePullRequestMutationVariables>;
export const CommitDocument = gql`
    query Commit($commitId: ID!) {
  commit(id: $commitId) {
    id
    parent {
      id
      schema {
        id
        code
      }
      implementation {
        id
        expressionJson
        splitsJson
        eventTypesJson
        featuresJson
      }
      configJson
    }
    schema {
      id
      code
    }
    implementation {
      id
      expressionJson
      splitsJson
      eventTypesJson
      featuresJson
    }
    configJson
    author {
      id
      displayName
      email
      imageUrl
    }
    message
    createdAt
  }
}
    `;

/**
 * __useCommitQuery__
 *
 * To run a query within a React component, call `useCommitQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommitQuery({
 *   variables: {
 *      commitId: // value for 'commitId'
 *   },
 * });
 */
export function useCommitQuery(baseOptions: Apollo.QueryHookOptions<CommitQuery, CommitQueryVariables> & ({ variables: CommitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommitQuery, CommitQueryVariables>(CommitDocument, options);
      }
export function useCommitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommitQuery, CommitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommitQuery, CommitQueryVariables>(CommitDocument, options);
        }
export function useCommitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommitQuery, CommitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommitQuery, CommitQueryVariables>(CommitDocument, options);
        }
export type CommitQueryHookResult = ReturnType<typeof useCommitQuery>;
export type CommitLazyQueryHookResult = ReturnType<typeof useCommitLazyQuery>;
export type CommitSuspenseQueryHookResult = ReturnType<typeof useCommitSuspenseQuery>;
export type CommitQueryResult = Apollo.QueryResult<CommitQuery, CommitQueryVariables>;
export const CommitSyncsDocument = gql`
    query CommitSyncs($commitId: ID!) {
  commitSyncs(id: $commitId) {
    id
    type
    status
  }
}
    `;

/**
 * __useCommitSyncsQuery__
 *
 * To run a query within a React component, call `useCommitSyncsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommitSyncsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommitSyncsQuery({
 *   variables: {
 *      commitId: // value for 'commitId'
 *   },
 * });
 */
export function useCommitSyncsQuery(baseOptions: Apollo.QueryHookOptions<CommitSyncsQuery, CommitSyncsQueryVariables> & ({ variables: CommitSyncsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommitSyncsQuery, CommitSyncsQueryVariables>(CommitSyncsDocument, options);
      }
export function useCommitSyncsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommitSyncsQuery, CommitSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommitSyncsQuery, CommitSyncsQueryVariables>(CommitSyncsDocument, options);
        }
export function useCommitSyncsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommitSyncsQuery, CommitSyncsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommitSyncsQuery, CommitSyncsQueryVariables>(CommitSyncsDocument, options);
        }
export type CommitSyncsQueryHookResult = ReturnType<typeof useCommitSyncsQuery>;
export type CommitSyncsLazyQueryHookResult = ReturnType<typeof useCommitSyncsLazyQuery>;
export type CommitSyncsSuspenseQueryHookResult = ReturnType<typeof useCommitSyncsSuspenseQuery>;
export type CommitSyncsQueryResult = Apollo.QueryResult<CommitSyncsQuery, CommitSyncsQueryVariables>;
export const CreateAnalyticsViewDocument = gql`
    mutation CreateAnalyticsView($input: CreateAnalyticsViewInput!) {
  createAnalyticsView(input: $input)
}
    `;
export type CreateAnalyticsViewMutationFn = Apollo.MutationFunction<CreateAnalyticsViewMutation, CreateAnalyticsViewMutationVariables>;

/**
 * __useCreateAnalyticsViewMutation__
 *
 * To run a mutation, you first call `useCreateAnalyticsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnalyticsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnalyticsViewMutation, { data, loading, error }] = useCreateAnalyticsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnalyticsViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnalyticsViewMutation, CreateAnalyticsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnalyticsViewMutation, CreateAnalyticsViewMutationVariables>(CreateAnalyticsViewDocument, options);
      }
export type CreateAnalyticsViewMutationHookResult = ReturnType<typeof useCreateAnalyticsViewMutation>;
export type CreateAnalyticsViewMutationResult = Apollo.MutationResult<CreateAnalyticsViewMutation>;
export type CreateAnalyticsViewMutationOptions = Apollo.BaseMutationOptions<CreateAnalyticsViewMutation, CreateAnalyticsViewMutationVariables>;
export const CreateBranchDocument = gql`
    mutation CreateBranch($input: CreateBranchInput!) {
  createBranch(input: $input)
}
    `;
export type CreateBranchMutationFn = Apollo.MutationFunction<CreateBranchMutation, CreateBranchMutationVariables>;

/**
 * __useCreateBranchMutation__
 *
 * To run a mutation, you first call `useCreateBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBranchMutation, { data, loading, error }] = useCreateBranchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBranchMutation(baseOptions?: Apollo.MutationHookOptions<CreateBranchMutation, CreateBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBranchMutation, CreateBranchMutationVariables>(CreateBranchDocument, options);
      }
export type CreateBranchMutationHookResult = ReturnType<typeof useCreateBranchMutation>;
export type CreateBranchMutationResult = Apollo.MutationResult<CreateBranchMutation>;
export type CreateBranchMutationOptions = Apollo.BaseMutationOptions<CreateBranchMutation, CreateBranchMutationVariables>;
export const CreateBusinessDocument = gql`
    mutation CreateBusiness($input: CreateBusinessInput!) {
  createBusiness(input: $input) {
    newBusinessId
    upgradePlanUrl
  }
}
    `;
export type CreateBusinessMutationFn = Apollo.MutationFunction<CreateBusinessMutation, CreateBusinessMutationVariables>;

/**
 * __useCreateBusinessMutation__
 *
 * To run a mutation, you first call `useCreateBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessMutation, { data, loading, error }] = useCreateBusinessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBusinessMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessMutation, CreateBusinessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessMutation, CreateBusinessMutationVariables>(CreateBusinessDocument, options);
      }
export type CreateBusinessMutationHookResult = ReturnType<typeof useCreateBusinessMutation>;
export type CreateBusinessMutationResult = Apollo.MutationResult<CreateBusinessMutation>;
export type CreateBusinessMutationOptions = Apollo.BaseMutationOptions<CreateBusinessMutation, CreateBusinessMutationVariables>;
export const CreateCommitDocument = gql`
    mutation CreateCommit($input: CreateCommitInput!) {
  createCommit(input: $input) {
    newCommitId
    newPullRequestId
    newBranchName
    syncs {
      id
      type
      status
    }
  }
}
    `;
export type CreateCommitMutationFn = Apollo.MutationFunction<CreateCommitMutation, CreateCommitMutationVariables>;

/**
 * __useCreateCommitMutation__
 *
 * To run a mutation, you first call `useCreateCommitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommitMutation, { data, loading, error }] = useCreateCommitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommitMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommitMutation, CreateCommitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommitMutation, CreateCommitMutationVariables>(CreateCommitDocument, options);
      }
export type CreateCommitMutationHookResult = ReturnType<typeof useCreateCommitMutation>;
export type CreateCommitMutationResult = Apollo.MutationResult<CreateCommitMutation>;
export type CreateCommitMutationOptions = Apollo.BaseMutationOptions<CreateCommitMutation, CreateCommitMutationVariables>;
export const CreateInvitesDocument = gql`
    mutation CreateInvites($input: CreateInvitesInput!) {
  createInvites(input: $input)
}
    `;
export type CreateInvitesMutationFn = Apollo.MutationFunction<CreateInvitesMutation, CreateInvitesMutationVariables>;

/**
 * __useCreateInvitesMutation__
 *
 * To run a mutation, you first call `useCreateInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvitesMutation, { data, loading, error }] = useCreateInvitesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvitesMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvitesMutation, CreateInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvitesMutation, CreateInvitesMutationVariables>(CreateInvitesDocument, options);
      }
export type CreateInvitesMutationHookResult = ReturnType<typeof useCreateInvitesMutation>;
export type CreateInvitesMutationResult = Apollo.MutationResult<CreateInvitesMutation>;
export type CreateInvitesMutationOptions = Apollo.BaseMutationOptions<CreateInvitesMutation, CreateInvitesMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input)
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateProjectTokenDocument = gql`
    mutation CreateProjectToken($input: CreateProjectTokenInput!) {
  createProjectToken(input: $input)
}
    `;
export type CreateProjectTokenMutationFn = Apollo.MutationFunction<CreateProjectTokenMutation, CreateProjectTokenMutationVariables>;

/**
 * __useCreateProjectTokenMutation__
 *
 * To run a mutation, you first call `useCreateProjectTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectTokenMutation, { data, loading, error }] = useCreateProjectTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectTokenMutation, CreateProjectTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectTokenMutation, CreateProjectTokenMutationVariables>(CreateProjectTokenDocument, options);
      }
export type CreateProjectTokenMutationHookResult = ReturnType<typeof useCreateProjectTokenMutation>;
export type CreateProjectTokenMutationResult = Apollo.MutationResult<CreateProjectTokenMutation>;
export type CreateProjectTokenMutationOptions = Apollo.BaseMutationOptions<CreateProjectTokenMutation, CreateProjectTokenMutationVariables>;
export const CreatePullRequestDocument = gql`
    mutation CreatePullRequest($input: CreatePullRequestInput!) {
  createPullRequest(input: $input)
}
    `;
export type CreatePullRequestMutationFn = Apollo.MutationFunction<CreatePullRequestMutation, CreatePullRequestMutationVariables>;

/**
 * __useCreatePullRequestMutation__
 *
 * To run a mutation, you first call `useCreatePullRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePullRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPullRequestMutation, { data, loading, error }] = useCreatePullRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePullRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePullRequestMutation, CreatePullRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePullRequestMutation, CreatePullRequestMutationVariables>(CreatePullRequestDocument, options);
      }
export type CreatePullRequestMutationHookResult = ReturnType<typeof useCreatePullRequestMutation>;
export type CreatePullRequestMutationResult = Apollo.MutationResult<CreatePullRequestMutation>;
export type CreatePullRequestMutationOptions = Apollo.BaseMutationOptions<CreatePullRequestMutation, CreatePullRequestMutationVariables>;
export const CreatePullRequestCommentDocument = gql`
    mutation CreatePullRequestComment($input: CreatePullRequestCommentInput!) {
  createPullRequestComment(input: $input)
}
    `;
export type CreatePullRequestCommentMutationFn = Apollo.MutationFunction<CreatePullRequestCommentMutation, CreatePullRequestCommentMutationVariables>;

/**
 * __useCreatePullRequestCommentMutation__
 *
 * To run a mutation, you first call `useCreatePullRequestCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePullRequestCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPullRequestCommentMutation, { data, loading, error }] = useCreatePullRequestCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePullRequestCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePullRequestCommentMutation, CreatePullRequestCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePullRequestCommentMutation, CreatePullRequestCommentMutationVariables>(CreatePullRequestCommentDocument, options);
      }
export type CreatePullRequestCommentMutationHookResult = ReturnType<typeof useCreatePullRequestCommentMutation>;
export type CreatePullRequestCommentMutationResult = Apollo.MutationResult<CreatePullRequestCommentMutation>;
export type CreatePullRequestCommentMutationOptions = Apollo.BaseMutationOptions<CreatePullRequestCommentMutation, CreatePullRequestCommentMutationVariables>;
export const CreateVercelEdgeConfigStoreDocument = gql`
    mutation CreateVercelEdgeConfigStore($input: CreateVercelEdgeConfigStoreInput!) {
  createVercelEdgeConfigStore(input: $input)
}
    `;
export type CreateVercelEdgeConfigStoreMutationFn = Apollo.MutationFunction<CreateVercelEdgeConfigStoreMutation, CreateVercelEdgeConfigStoreMutationVariables>;

/**
 * __useCreateVercelEdgeConfigStoreMutation__
 *
 * To run a mutation, you first call `useCreateVercelEdgeConfigStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVercelEdgeConfigStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVercelEdgeConfigStoreMutation, { data, loading, error }] = useCreateVercelEdgeConfigStoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVercelEdgeConfigStoreMutation(baseOptions?: Apollo.MutationHookOptions<CreateVercelEdgeConfigStoreMutation, CreateVercelEdgeConfigStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVercelEdgeConfigStoreMutation, CreateVercelEdgeConfigStoreMutationVariables>(CreateVercelEdgeConfigStoreDocument, options);
      }
export type CreateVercelEdgeConfigStoreMutationHookResult = ReturnType<typeof useCreateVercelEdgeConfigStoreMutation>;
export type CreateVercelEdgeConfigStoreMutationResult = Apollo.MutationResult<CreateVercelEdgeConfigStoreMutation>;
export type CreateVercelEdgeConfigStoreMutationOptions = Apollo.BaseMutationOptions<CreateVercelEdgeConfigStoreMutation, CreateVercelEdgeConfigStoreMutationVariables>;
export const CreateWebhookDocument = gql`
    mutation CreateWebhook($input: CreateWebhookInput!) {
  createWebhook(input: $input)
}
    `;
export type CreateWebhookMutationFn = Apollo.MutationFunction<CreateWebhookMutation, CreateWebhookMutationVariables>;

/**
 * __useCreateWebhookMutation__
 *
 * To run a mutation, you first call `useCreateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookMutation, { data, loading, error }] = useCreateWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebhookMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebhookMutation, CreateWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebhookMutation, CreateWebhookMutationVariables>(CreateWebhookDocument, options);
      }
export type CreateWebhookMutationHookResult = ReturnType<typeof useCreateWebhookMutation>;
export type CreateWebhookMutationResult = Apollo.MutationResult<CreateWebhookMutation>;
export type CreateWebhookMutationOptions = Apollo.BaseMutationOptions<CreateWebhookMutation, CreateWebhookMutationVariables>;
export const DeleteAnalyticsViewDocument = gql`
    mutation DeleteAnalyticsView($input: DeleteAnalyticsViewInput!) {
  deleteAnalyticsView(input: $input)
}
    `;
export type DeleteAnalyticsViewMutationFn = Apollo.MutationFunction<DeleteAnalyticsViewMutation, DeleteAnalyticsViewMutationVariables>;

/**
 * __useDeleteAnalyticsViewMutation__
 *
 * To run a mutation, you first call `useDeleteAnalyticsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnalyticsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnalyticsViewMutation, { data, loading, error }] = useDeleteAnalyticsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnalyticsViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnalyticsViewMutation, DeleteAnalyticsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnalyticsViewMutation, DeleteAnalyticsViewMutationVariables>(DeleteAnalyticsViewDocument, options);
      }
export type DeleteAnalyticsViewMutationHookResult = ReturnType<typeof useDeleteAnalyticsViewMutation>;
export type DeleteAnalyticsViewMutationResult = Apollo.MutationResult<DeleteAnalyticsViewMutation>;
export type DeleteAnalyticsViewMutationOptions = Apollo.BaseMutationOptions<DeleteAnalyticsViewMutation, DeleteAnalyticsViewMutationVariables>;
export const DeleteProjectTokenDocument = gql`
    mutation DeleteProjectToken($input: DeleteProjectTokenInput!) {
  deleteProjectToken(input: $input)
}
    `;
export type DeleteProjectTokenMutationFn = Apollo.MutationFunction<DeleteProjectTokenMutation, DeleteProjectTokenMutationVariables>;

/**
 * __useDeleteProjectTokenMutation__
 *
 * To run a mutation, you first call `useDeleteProjectTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectTokenMutation, { data, loading, error }] = useDeleteProjectTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProjectTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectTokenMutation, DeleteProjectTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectTokenMutation, DeleteProjectTokenMutationVariables>(DeleteProjectTokenDocument, options);
      }
export type DeleteProjectTokenMutationHookResult = ReturnType<typeof useDeleteProjectTokenMutation>;
export type DeleteProjectTokenMutationResult = Apollo.MutationResult<DeleteProjectTokenMutation>;
export type DeleteProjectTokenMutationOptions = Apollo.BaseMutationOptions<DeleteProjectTokenMutation, DeleteProjectTokenMutationVariables>;
export const EvaluationsDocument = gql`
    query Evaluations($input: EvaluationsJsonInput!) {
  evaluationsJson(input: $input)
}
    `;

/**
 * __useEvaluationsQuery__
 *
 * To run a query within a React component, call `useEvaluationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEvaluationsQuery(baseOptions: Apollo.QueryHookOptions<EvaluationsQuery, EvaluationsQueryVariables> & ({ variables: EvaluationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationsQuery, EvaluationsQueryVariables>(EvaluationsDocument, options);
      }
export function useEvaluationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationsQuery, EvaluationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationsQuery, EvaluationsQueryVariables>(EvaluationsDocument, options);
        }
export function useEvaluationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationsQuery, EvaluationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationsQuery, EvaluationsQueryVariables>(EvaluationsDocument, options);
        }
export type EvaluationsQueryHookResult = ReturnType<typeof useEvaluationsQuery>;
export type EvaluationsLazyQueryHookResult = ReturnType<typeof useEvaluationsLazyQuery>;
export type EvaluationsSuspenseQueryHookResult = ReturnType<typeof useEvaluationsSuspenseQuery>;
export type EvaluationsQueryResult = Apollo.QueryResult<EvaluationsQuery, EvaluationsQueryVariables>;
export const EvictUserDocument = gql`
    mutation EvictUser($input: EvictUserInput!) {
  evictUser(input: $input)
}
    `;
export type EvictUserMutationFn = Apollo.MutationFunction<EvictUserMutation, EvictUserMutationVariables>;

/**
 * __useEvictUserMutation__
 *
 * To run a mutation, you first call `useEvictUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvictUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evictUserMutation, { data, loading, error }] = useEvictUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEvictUserMutation(baseOptions?: Apollo.MutationHookOptions<EvictUserMutation, EvictUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvictUserMutation, EvictUserMutationVariables>(EvictUserDocument, options);
      }
export type EvictUserMutationHookResult = ReturnType<typeof useEvictUserMutation>;
export type EvictUserMutationResult = Apollo.MutationResult<EvictUserMutation>;
export type EvictUserMutationOptions = Apollo.BaseMutationOptions<EvictUserMutation, EvictUserMutationVariables>;
export const FunnelDataDocument = gql`
    query FunnelData($input: FunnelDataJsonInput!) {
  funnelDataJson(input: $input)
}
    `;

/**
 * __useFunnelDataQuery__
 *
 * To run a query within a React component, call `useFunnelDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFunnelDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFunnelDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFunnelDataQuery(baseOptions: Apollo.QueryHookOptions<FunnelDataQuery, FunnelDataQueryVariables> & ({ variables: FunnelDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FunnelDataQuery, FunnelDataQueryVariables>(FunnelDataDocument, options);
      }
export function useFunnelDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FunnelDataQuery, FunnelDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FunnelDataQuery, FunnelDataQueryVariables>(FunnelDataDocument, options);
        }
export function useFunnelDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FunnelDataQuery, FunnelDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FunnelDataQuery, FunnelDataQueryVariables>(FunnelDataDocument, options);
        }
export type FunnelDataQueryHookResult = ReturnType<typeof useFunnelDataQuery>;
export type FunnelDataLazyQueryHookResult = ReturnType<typeof useFunnelDataLazyQuery>;
export type FunnelDataSuspenseQueryHookResult = ReturnType<typeof useFunnelDataSuspenseQuery>;
export type FunnelDataQueryResult = Apollo.QueryResult<FunnelDataQuery, FunnelDataQueryVariables>;
export const LogsDocument = gql`
    query Logs($input: LogsInput!) {
  logs(input: $input) {
    id
    type
    level
    message
    createdAt
    metadataJson
    commitId
  }
}
    `;

/**
 * __useLogsQuery__
 *
 * To run a query within a React component, call `useLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogsQuery(baseOptions: Apollo.QueryHookOptions<LogsQuery, LogsQueryVariables> & ({ variables: LogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogsQuery, LogsQueryVariables>(LogsDocument, options);
      }
export function useLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogsQuery, LogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogsQuery, LogsQueryVariables>(LogsDocument, options);
        }
export function useLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogsQuery, LogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogsQuery, LogsQueryVariables>(LogsDocument, options);
        }
export type LogsQueryHookResult = ReturnType<typeof useLogsQuery>;
export type LogsLazyQueryHookResult = ReturnType<typeof useLogsLazyQuery>;
export type LogsSuspenseQueryHookResult = ReturnType<typeof useLogsSuspenseQuery>;
export type LogsQueryResult = Apollo.QueryResult<LogsQuery, LogsQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    email
    emailVerified
    displayName
    intercomToken
    metadataJson
  }
  primaryBusiness {
    id
    business {
      id
      type
      plan
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MergePullRequestDocument = gql`
    mutation MergePullRequest($input: MergePullRequestInput!) {
  mergePullRequest(input: $input)
}
    `;
export type MergePullRequestMutationFn = Apollo.MutationFunction<MergePullRequestMutation, MergePullRequestMutationVariables>;

/**
 * __useMergePullRequestMutation__
 *
 * To run a mutation, you first call `useMergePullRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergePullRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergePullRequestMutation, { data, loading, error }] = useMergePullRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergePullRequestMutation(baseOptions?: Apollo.MutationHookOptions<MergePullRequestMutation, MergePullRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergePullRequestMutation, MergePullRequestMutationVariables>(MergePullRequestDocument, options);
      }
export type MergePullRequestMutationHookResult = ReturnType<typeof useMergePullRequestMutation>;
export type MergePullRequestMutationResult = Apollo.MutationResult<MergePullRequestMutation>;
export type MergePullRequestMutationOptions = Apollo.BaseMutationOptions<MergePullRequestMutation, MergePullRequestMutationVariables>;
export const PrimaryBusinessUsageDocument = gql`
    query PrimaryBusinessUsage {
  primaryBusiness {
    id
    business {
      id
      plan
      memberCount
      billedRequestCurrentMonthUsage
      billedEventCurrentMonthUsage
    }
  }
}
    `;

/**
 * __usePrimaryBusinessUsageQuery__
 *
 * To run a query within a React component, call `usePrimaryBusinessUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimaryBusinessUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimaryBusinessUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrimaryBusinessUsageQuery(baseOptions?: Apollo.QueryHookOptions<PrimaryBusinessUsageQuery, PrimaryBusinessUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimaryBusinessUsageQuery, PrimaryBusinessUsageQueryVariables>(PrimaryBusinessUsageDocument, options);
      }
export function usePrimaryBusinessUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimaryBusinessUsageQuery, PrimaryBusinessUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimaryBusinessUsageQuery, PrimaryBusinessUsageQueryVariables>(PrimaryBusinessUsageDocument, options);
        }
export function usePrimaryBusinessUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrimaryBusinessUsageQuery, PrimaryBusinessUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrimaryBusinessUsageQuery, PrimaryBusinessUsageQueryVariables>(PrimaryBusinessUsageDocument, options);
        }
export type PrimaryBusinessUsageQueryHookResult = ReturnType<typeof usePrimaryBusinessUsageQuery>;
export type PrimaryBusinessUsageLazyQueryHookResult = ReturnType<typeof usePrimaryBusinessUsageLazyQuery>;
export type PrimaryBusinessUsageSuspenseQueryHookResult = ReturnType<typeof usePrimaryBusinessUsageSuspenseQuery>;
export type PrimaryBusinessUsageQueryResult = Apollo.QueryResult<PrimaryBusinessUsageQuery, PrimaryBusinessUsageQueryVariables>;
export const ProjectDocument = gql`
    query Project($projectId: ID!) {
  me {
    id
    displayName
    imageUrl
  }
  primaryBusiness {
    id
    role
  }
  project(id: $projectId) {
    id
    business {
      id
      name
      type
    }
    name
    tokensJson
    showOnboarding
    setupCompleted
    branches {
      id
      name
      createdAt
      activeCommit {
        id
      }
      author {
        id
      }
    }
    pullRequests {
      id
      status
      createdAt
      intoBranch {
        id
        name
      }
      fromBranch {
        id
        name
      }
      author {
        id
        displayName
        imageUrl
      }
    }
    analyticsViews {
      id
      name
      configJson
    }
    webhooks {
      id
      name
      url
      eventTypes
      secret
      active
      createdAt
    }
  }
}
    `;

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables> & ({ variables: ProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
      }
export function useProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
        }
export function useProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
        }
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectSuspenseQueryHookResult = ReturnType<typeof useProjectSuspenseQuery>;
export type ProjectQueryResult = Apollo.QueryResult<ProjectQuery, ProjectQueryVariables>;
export const ProjectAnalyticsViewsDocument = gql`
    query ProjectAnalyticsViews($projectId: ID!) {
  project(id: $projectId) {
    id
    analyticsViews {
      id
      name
      configJson
      lastRefreshedAt
    }
  }
}
    `;

/**
 * __useProjectAnalyticsViewsQuery__
 *
 * To run a query within a React component, call `useProjectAnalyticsViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAnalyticsViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAnalyticsViewsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectAnalyticsViewsQuery(baseOptions: Apollo.QueryHookOptions<ProjectAnalyticsViewsQuery, ProjectAnalyticsViewsQueryVariables> & ({ variables: ProjectAnalyticsViewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectAnalyticsViewsQuery, ProjectAnalyticsViewsQueryVariables>(ProjectAnalyticsViewsDocument, options);
      }
export function useProjectAnalyticsViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectAnalyticsViewsQuery, ProjectAnalyticsViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectAnalyticsViewsQuery, ProjectAnalyticsViewsQueryVariables>(ProjectAnalyticsViewsDocument, options);
        }
export function useProjectAnalyticsViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectAnalyticsViewsQuery, ProjectAnalyticsViewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectAnalyticsViewsQuery, ProjectAnalyticsViewsQueryVariables>(ProjectAnalyticsViewsDocument, options);
        }
export type ProjectAnalyticsViewsQueryHookResult = ReturnType<typeof useProjectAnalyticsViewsQuery>;
export type ProjectAnalyticsViewsLazyQueryHookResult = ReturnType<typeof useProjectAnalyticsViewsLazyQuery>;
export type ProjectAnalyticsViewsSuspenseQueryHookResult = ReturnType<typeof useProjectAnalyticsViewsSuspenseQuery>;
export type ProjectAnalyticsViewsQueryResult = Apollo.QueryResult<ProjectAnalyticsViewsQuery, ProjectAnalyticsViewsQueryVariables>;
export const ProjectBranchDocument = gql`
    query ProjectBranch($projectId: ID!, $branchName: String!) {
  projectBranch(projectId: $projectId, branchName: $branchName) {
    id
    name
    author {
      id
    }
    activeCommit {
      id
      schema {
        code
      }
      implementation {
        expressionJson
        splitsJson
        eventTypesJson
        featuresJson
      }
      configJson
    }
    commits {
      id
      author {
        id
        displayName
        email
        imageUrl
      }
      message
      createdAt
    }
  }
}
    `;

/**
 * __useProjectBranchQuery__
 *
 * To run a query within a React component, call `useProjectBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBranchQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      branchName: // value for 'branchName'
 *   },
 * });
 */
export function useProjectBranchQuery(baseOptions: Apollo.QueryHookOptions<ProjectBranchQuery, ProjectBranchQueryVariables> & ({ variables: ProjectBranchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectBranchQuery, ProjectBranchQueryVariables>(ProjectBranchDocument, options);
      }
export function useProjectBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectBranchQuery, ProjectBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectBranchQuery, ProjectBranchQueryVariables>(ProjectBranchDocument, options);
        }
export function useProjectBranchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectBranchQuery, ProjectBranchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectBranchQuery, ProjectBranchQueryVariables>(ProjectBranchDocument, options);
        }
export type ProjectBranchQueryHookResult = ReturnType<typeof useProjectBranchQuery>;
export type ProjectBranchLazyQueryHookResult = ReturnType<typeof useProjectBranchLazyQuery>;
export type ProjectBranchSuspenseQueryHookResult = ReturnType<typeof useProjectBranchSuspenseQuery>;
export type ProjectBranchQueryResult = Apollo.QueryResult<ProjectBranchQuery, ProjectBranchQueryVariables>;
export const ProjectExportUrlDocument = gql`
    mutation ProjectExportUrl($input: ProjectExportUrlInput!) {
  projectExportUrl(input: $input)
}
    `;
export type ProjectExportUrlMutationFn = Apollo.MutationFunction<ProjectExportUrlMutation, ProjectExportUrlMutationVariables>;

/**
 * __useProjectExportUrlMutation__
 *
 * To run a mutation, you first call `useProjectExportUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectExportUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectExportUrlMutation, { data, loading, error }] = useProjectExportUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectExportUrlMutation(baseOptions?: Apollo.MutationHookOptions<ProjectExportUrlMutation, ProjectExportUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProjectExportUrlMutation, ProjectExportUrlMutationVariables>(ProjectExportUrlDocument, options);
      }
export type ProjectExportUrlMutationHookResult = ReturnType<typeof useProjectExportUrlMutation>;
export type ProjectExportUrlMutationResult = Apollo.MutationResult<ProjectExportUrlMutation>;
export type ProjectExportUrlMutationOptions = Apollo.BaseMutationOptions<ProjectExportUrlMutation, ProjectExportUrlMutationVariables>;
export const ProjectSetupDocument = gql`
    query ProjectSetup($projectId: ID!) {
  project(id: $projectId) {
    id
    showOnboarding
    setupCompleted
    generatedClient
    evaluatedFlags
  }
}
    `;

/**
 * __useProjectSetupQuery__
 *
 * To run a query within a React component, call `useProjectSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectSetupQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectSetupQuery(baseOptions: Apollo.QueryHookOptions<ProjectSetupQuery, ProjectSetupQueryVariables> & ({ variables: ProjectSetupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectSetupQuery, ProjectSetupQueryVariables>(ProjectSetupDocument, options);
      }
export function useProjectSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectSetupQuery, ProjectSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectSetupQuery, ProjectSetupQueryVariables>(ProjectSetupDocument, options);
        }
export function useProjectSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectSetupQuery, ProjectSetupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectSetupQuery, ProjectSetupQueryVariables>(ProjectSetupDocument, options);
        }
export type ProjectSetupQueryHookResult = ReturnType<typeof useProjectSetupQuery>;
export type ProjectSetupLazyQueryHookResult = ReturnType<typeof useProjectSetupLazyQuery>;
export type ProjectSetupSuspenseQueryHookResult = ReturnType<typeof useProjectSetupSuspenseQuery>;
export type ProjectSetupQueryResult = Apollo.QueryResult<ProjectSetupQuery, ProjectSetupQueryVariables>;
export const PullRequestDocument = gql`
    query PullRequest($pullRequestId: ID!) {
  pullRequest(id: $pullRequestId) {
    id
    status
    createdAt
    intoBranch {
      id
      name
      activeCommit {
        id
        schema {
          id
          code
        }
        implementation {
          id
          expressionJson
          splitsJson
          eventTypesJson
          featuresJson
        }
        configJson
      }
      commits {
        id
      }
    }
    fromBranch {
      id
      name
      author {
        id
      }
      archived
      activeCommit {
        id
        parent {
          id
        }
        schema {
          id
          code
        }
        implementation {
          id
          expressionJson
          splitsJson
          eventTypesJson
          featuresJson
        }
        configJson
      }
    }
    intoBranchCommit {
      id
      schema {
        id
        code
      }
      implementation {
        id
        expressionJson
        splitsJson
        eventTypesJson
        featuresJson
      }
      configJson
    }
    fromBranchCommit {
      id
      schema {
        id
        code
      }
      implementation {
        id
        expressionJson
        splitsJson
        eventTypesJson
        featuresJson
      }
      configJson
    }
    latestCommonCommit {
      id
      parent {
        id
      }
      schema {
        id
        code
      }
      implementation {
        id
        expressionJson
        splitsJson
        eventTypesJson
        featuresJson
      }
      configJson
    }
    author {
      id
      displayName
      imageUrl
    }
    comments {
      id
      type
      message
      createdAt
      author {
        id
        displayName
        imageUrl
      }
    }
  }
}
    `;

/**
 * __usePullRequestQuery__
 *
 * To run a query within a React component, call `usePullRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePullRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePullRequestQuery({
 *   variables: {
 *      pullRequestId: // value for 'pullRequestId'
 *   },
 * });
 */
export function usePullRequestQuery(baseOptions: Apollo.QueryHookOptions<PullRequestQuery, PullRequestQueryVariables> & ({ variables: PullRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PullRequestQuery, PullRequestQueryVariables>(PullRequestDocument, options);
      }
export function usePullRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PullRequestQuery, PullRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PullRequestQuery, PullRequestQueryVariables>(PullRequestDocument, options);
        }
export function usePullRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PullRequestQuery, PullRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PullRequestQuery, PullRequestQueryVariables>(PullRequestDocument, options);
        }
export type PullRequestQueryHookResult = ReturnType<typeof usePullRequestQuery>;
export type PullRequestLazyQueryHookResult = ReturnType<typeof usePullRequestLazyQuery>;
export type PullRequestSuspenseQueryHookResult = ReturnType<typeof usePullRequestSuspenseQuery>;
export type PullRequestQueryResult = Apollo.QueryResult<PullRequestQuery, PullRequestQueryVariables>;
export const RephraseTextDocument = gql`
    mutation RephraseText($input: RephraseTextInput!) {
  rephraseText(input: $input) {
    id
    text
  }
}
    `;
export type RephraseTextMutationFn = Apollo.MutationFunction<RephraseTextMutation, RephraseTextMutationVariables>;

/**
 * __useRephraseTextMutation__
 *
 * To run a mutation, you first call `useRephraseTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRephraseTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rephraseTextMutation, { data, loading, error }] = useRephraseTextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRephraseTextMutation(baseOptions?: Apollo.MutationHookOptions<RephraseTextMutation, RephraseTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RephraseTextMutation, RephraseTextMutationVariables>(RephraseTextDocument, options);
      }
export type RephraseTextMutationHookResult = ReturnType<typeof useRephraseTextMutation>;
export type RephraseTextMutationResult = Apollo.MutationResult<RephraseTextMutation>;
export type RephraseTextMutationOptions = Apollo.BaseMutationOptions<RephraseTextMutation, RephraseTextMutationVariables>;
export const ReportCrashDocument = gql`
    mutation ReportCrash($input: ReportCrashInput!) {
  reportCrash(input: $input)
}
    `;
export type ReportCrashMutationFn = Apollo.MutationFunction<ReportCrashMutation, ReportCrashMutationVariables>;

/**
 * __useReportCrashMutation__
 *
 * To run a mutation, you first call `useReportCrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCrashMutation, { data, loading, error }] = useReportCrashMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCrashMutation(baseOptions?: Apollo.MutationHookOptions<ReportCrashMutation, ReportCrashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportCrashMutation, ReportCrashMutationVariables>(ReportCrashDocument, options);
      }
export type ReportCrashMutationHookResult = ReturnType<typeof useReportCrashMutation>;
export type ReportCrashMutationResult = Apollo.MutationResult<ReportCrashMutation>;
export type ReportCrashMutationOptions = Apollo.BaseMutationOptions<ReportCrashMutation, ReportCrashMutationVariables>;
export const RevokeInviteDocument = gql`
    mutation RevokeInvite($input: RevokeInviteInput!) {
  revokeInvite(input: $input)
}
    `;
export type RevokeInviteMutationFn = Apollo.MutationFunction<RevokeInviteMutation, RevokeInviteMutationVariables>;

/**
 * __useRevokeInviteMutation__
 *
 * To run a mutation, you first call `useRevokeInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeInviteMutation, { data, loading, error }] = useRevokeInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeInviteMutation(baseOptions?: Apollo.MutationHookOptions<RevokeInviteMutation, RevokeInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeInviteMutation, RevokeInviteMutationVariables>(RevokeInviteDocument, options);
      }
export type RevokeInviteMutationHookResult = ReturnType<typeof useRevokeInviteMutation>;
export type RevokeInviteMutationResult = Apollo.MutationResult<RevokeInviteMutation>;
export type RevokeInviteMutationOptions = Apollo.BaseMutationOptions<RevokeInviteMutation, RevokeInviteMutationVariables>;
export const SendVerifyAndInviteEmailDocument = gql`
    mutation SendVerifyAndInviteEmail($input: SendVerifyAndInviteEmailInput!) {
  sendVerifyAndInviteEmail(input: $input)
}
    `;
export type SendVerifyAndInviteEmailMutationFn = Apollo.MutationFunction<SendVerifyAndInviteEmailMutation, SendVerifyAndInviteEmailMutationVariables>;

/**
 * __useSendVerifyAndInviteEmailMutation__
 *
 * To run a mutation, you first call `useSendVerifyAndInviteEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerifyAndInviteEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerifyAndInviteEmailMutation, { data, loading, error }] = useSendVerifyAndInviteEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendVerifyAndInviteEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendVerifyAndInviteEmailMutation, SendVerifyAndInviteEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVerifyAndInviteEmailMutation, SendVerifyAndInviteEmailMutationVariables>(SendVerifyAndInviteEmailDocument, options);
      }
export type SendVerifyAndInviteEmailMutationHookResult = ReturnType<typeof useSendVerifyAndInviteEmailMutation>;
export type SendVerifyAndInviteEmailMutationResult = Apollo.MutationResult<SendVerifyAndInviteEmailMutation>;
export type SendVerifyAndInviteEmailMutationOptions = Apollo.BaseMutationOptions<SendVerifyAndInviteEmailMutation, SendVerifyAndInviteEmailMutationVariables>;
export const TableDataDocument = gql`
    query TableData($input: TableDataJsonInput!) {
  tableDataJson(input: $input)
}
    `;

/**
 * __useTableDataQuery__
 *
 * To run a query within a React component, call `useTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTableDataQuery(baseOptions: Apollo.QueryHookOptions<TableDataQuery, TableDataQueryVariables> & ({ variables: TableDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableDataQuery, TableDataQueryVariables>(TableDataDocument, options);
      }
export function useTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableDataQuery, TableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableDataQuery, TableDataQueryVariables>(TableDataDocument, options);
        }
export function useTableDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TableDataQuery, TableDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TableDataQuery, TableDataQueryVariables>(TableDataDocument, options);
        }
export type TableDataQueryHookResult = ReturnType<typeof useTableDataQuery>;
export type TableDataLazyQueryHookResult = ReturnType<typeof useTableDataLazyQuery>;
export type TableDataSuspenseQueryHookResult = ReturnType<typeof useTableDataSuspenseQuery>;
export type TableDataQueryResult = Apollo.QueryResult<TableDataQuery, TableDataQueryVariables>;
export const UpdateAnalyticsViewDocument = gql`
    mutation UpdateAnalyticsView($input: UpdateAnalyticsViewInput!) {
  updateAnalyticsView(input: $input)
}
    `;
export type UpdateAnalyticsViewMutationFn = Apollo.MutationFunction<UpdateAnalyticsViewMutation, UpdateAnalyticsViewMutationVariables>;

/**
 * __useUpdateAnalyticsViewMutation__
 *
 * To run a mutation, you first call `useUpdateAnalyticsViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnalyticsViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnalyticsViewMutation, { data, loading, error }] = useUpdateAnalyticsViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnalyticsViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnalyticsViewMutation, UpdateAnalyticsViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnalyticsViewMutation, UpdateAnalyticsViewMutationVariables>(UpdateAnalyticsViewDocument, options);
      }
export type UpdateAnalyticsViewMutationHookResult = ReturnType<typeof useUpdateAnalyticsViewMutation>;
export type UpdateAnalyticsViewMutationResult = Apollo.MutationResult<UpdateAnalyticsViewMutation>;
export type UpdateAnalyticsViewMutationOptions = Apollo.BaseMutationOptions<UpdateAnalyticsViewMutation, UpdateAnalyticsViewMutationVariables>;
export const UpdateBillingDataDocument = gql`
    mutation UpdateBillingData($input: UpdateBillingDataInput!) {
  updateBillingData(input: $input)
}
    `;
export type UpdateBillingDataMutationFn = Apollo.MutationFunction<UpdateBillingDataMutation, UpdateBillingDataMutationVariables>;

/**
 * __useUpdateBillingDataMutation__
 *
 * To run a mutation, you first call `useUpdateBillingDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingDataMutation, { data, loading, error }] = useUpdateBillingDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingDataMutation, UpdateBillingDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingDataMutation, UpdateBillingDataMutationVariables>(UpdateBillingDataDocument, options);
      }
export type UpdateBillingDataMutationHookResult = ReturnType<typeof useUpdateBillingDataMutation>;
export type UpdateBillingDataMutationResult = Apollo.MutationResult<UpdateBillingDataMutation>;
export type UpdateBillingDataMutationOptions = Apollo.BaseMutationOptions<UpdateBillingDataMutation, UpdateBillingDataMutationVariables>;
export const UpdateBranchDocument = gql`
    mutation UpdateBranch($input: UpdateBranchInput!) {
  updateBranch(input: $input)
}
    `;
export type UpdateBranchMutationFn = Apollo.MutationFunction<UpdateBranchMutation, UpdateBranchMutationVariables>;

/**
 * __useUpdateBranchMutation__
 *
 * To run a mutation, you first call `useUpdateBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBranchMutation, { data, loading, error }] = useUpdateBranchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBranchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBranchMutation, UpdateBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBranchMutation, UpdateBranchMutationVariables>(UpdateBranchDocument, options);
      }
export type UpdateBranchMutationHookResult = ReturnType<typeof useUpdateBranchMutation>;
export type UpdateBranchMutationResult = Apollo.MutationResult<UpdateBranchMutation>;
export type UpdateBranchMutationOptions = Apollo.BaseMutationOptions<UpdateBranchMutation, UpdateBranchMutationVariables>;
export const UpdateBusinessDocument = gql`
    mutation UpdateBusiness($input: UpdateBusinessInput!) {
  updateBusiness(input: $input)
}
    `;
export type UpdateBusinessMutationFn = Apollo.MutationFunction<UpdateBusinessMutation, UpdateBusinessMutationVariables>;

/**
 * __useUpdateBusinessMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessMutation, { data, loading, error }] = useUpdateBusinessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessMutation, UpdateBusinessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessMutation, UpdateBusinessMutationVariables>(UpdateBusinessDocument, options);
      }
export type UpdateBusinessMutationHookResult = ReturnType<typeof useUpdateBusinessMutation>;
export type UpdateBusinessMutationResult = Apollo.MutationResult<UpdateBusinessMutation>;
export type UpdateBusinessMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessMutation, UpdateBusinessMutationVariables>;
export const UpdateBusinessUserRoleDocument = gql`
    mutation UpdateBusinessUserRole($input: UpdateBusinessUserRoleInput!) {
  updateBusinessUserRole(input: $input)
}
    `;
export type UpdateBusinessUserRoleMutationFn = Apollo.MutationFunction<UpdateBusinessUserRoleMutation, UpdateBusinessUserRoleMutationVariables>;

/**
 * __useUpdateBusinessUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessUserRoleMutation, { data, loading, error }] = useUpdateBusinessUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessUserRoleMutation, UpdateBusinessUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessUserRoleMutation, UpdateBusinessUserRoleMutationVariables>(UpdateBusinessUserRoleDocument, options);
      }
export type UpdateBusinessUserRoleMutationHookResult = ReturnType<typeof useUpdateBusinessUserRoleMutation>;
export type UpdateBusinessUserRoleMutationResult = Apollo.MutationResult<UpdateBusinessUserRoleMutation>;
export type UpdateBusinessUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessUserRoleMutation, UpdateBusinessUserRoleMutationVariables>;
export const UpdateMeDocument = gql`
    mutation UpdateMe($input: UpdateMeInput!) {
  updateMe(input: $input)
}
    `;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const UpdatePaymentMethodDocument = gql`
    mutation UpdatePaymentMethod($input: UpdatePaymentMethodInput!) {
  updatePaymentMethod(input: $input) {
    url
  }
}
    `;
export type UpdatePaymentMethodMutationFn = Apollo.MutationFunction<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>(UpdatePaymentMethodDocument, options);
      }
export type UpdatePaymentMethodMutationHookResult = ReturnType<typeof useUpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationResult = Apollo.MutationResult<UpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;
export const UpdatePlanDocument = gql`
    mutation UpdatePlan($input: UpdatePlanInput!) {
  updatePlan(input: $input)
}
    `;
export type UpdatePlanMutationFn = Apollo.MutationFunction<UpdatePlanMutation, UpdatePlanMutationVariables>;

/**
 * __useUpdatePlanMutation__
 *
 * To run a mutation, you first call `useUpdatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanMutation, { data, loading, error }] = useUpdatePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanMutation, UpdatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanMutation, UpdatePlanMutationVariables>(UpdatePlanDocument, options);
      }
export type UpdatePlanMutationHookResult = ReturnType<typeof useUpdatePlanMutation>;
export type UpdatePlanMutationResult = Apollo.MutationResult<UpdatePlanMutation>;
export type UpdatePlanMutationOptions = Apollo.BaseMutationOptions<UpdatePlanMutation, UpdatePlanMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($input: UpdateProjectInput!) {
  updateProject(input: $input)
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdatePullRequestCommentDocument = gql`
    mutation UpdatePullRequestComment($input: UpdatePullRequestCommentInput!) {
  updatePullRequestComment(input: $input)
}
    `;
export type UpdatePullRequestCommentMutationFn = Apollo.MutationFunction<UpdatePullRequestCommentMutation, UpdatePullRequestCommentMutationVariables>;

/**
 * __useUpdatePullRequestCommentMutation__
 *
 * To run a mutation, you first call `useUpdatePullRequestCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePullRequestCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePullRequestCommentMutation, { data, loading, error }] = useUpdatePullRequestCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePullRequestCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePullRequestCommentMutation, UpdatePullRequestCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePullRequestCommentMutation, UpdatePullRequestCommentMutationVariables>(UpdatePullRequestCommentDocument, options);
      }
export type UpdatePullRequestCommentMutationHookResult = ReturnType<typeof useUpdatePullRequestCommentMutation>;
export type UpdatePullRequestCommentMutationResult = Apollo.MutationResult<UpdatePullRequestCommentMutation>;
export type UpdatePullRequestCommentMutationOptions = Apollo.BaseMutationOptions<UpdatePullRequestCommentMutation, UpdatePullRequestCommentMutationVariables>;
export const UpdateWebhookDocument = gql`
    mutation UpdateWebhook($input: UpdateWebhookInput!) {
  updateWebhook(input: $input)
}
    `;
export type UpdateWebhookMutationFn = Apollo.MutationFunction<UpdateWebhookMutation, UpdateWebhookMutationVariables>;

/**
 * __useUpdateWebhookMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookMutation, { data, loading, error }] = useUpdateWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebhookMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebhookMutation, UpdateWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebhookMutation, UpdateWebhookMutationVariables>(UpdateWebhookDocument, options);
      }
export type UpdateWebhookMutationHookResult = ReturnType<typeof useUpdateWebhookMutation>;
export type UpdateWebhookMutationResult = Apollo.MutationResult<UpdateWebhookMutation>;
export type UpdateWebhookMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookMutation, UpdateWebhookMutationVariables>;
export const UpgradePlanDocument = gql`
    mutation UpgradePlan($input: UpgradePlanInput!) {
  upgradePlan(input: $input) {
    url
  }
}
    `;
export type UpgradePlanMutationFn = Apollo.MutationFunction<UpgradePlanMutation, UpgradePlanMutationVariables>;

/**
 * __useUpgradePlanMutation__
 *
 * To run a mutation, you first call `useUpgradePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradePlanMutation, { data, loading, error }] = useUpgradePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpgradePlanMutation(baseOptions?: Apollo.MutationHookOptions<UpgradePlanMutation, UpgradePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradePlanMutation, UpgradePlanMutationVariables>(UpgradePlanDocument, options);
      }
export type UpgradePlanMutationHookResult = ReturnType<typeof useUpgradePlanMutation>;
export type UpgradePlanMutationResult = Apollo.MutationResult<UpgradePlanMutation>;
export type UpgradePlanMutationOptions = Apollo.BaseMutationOptions<UpgradePlanMutation, UpgradePlanMutationVariables>;
export const VercelEdgeConfigStoresDocument = gql`
    query VercelEdgeConfigStores {
  primaryBusiness {
    id
    business {
      id
      vercelEdgeConfigStores
    }
  }
}
    `;

/**
 * __useVercelEdgeConfigStoresQuery__
 *
 * To run a query within a React component, call `useVercelEdgeConfigStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useVercelEdgeConfigStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVercelEdgeConfigStoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useVercelEdgeConfigStoresQuery(baseOptions?: Apollo.QueryHookOptions<VercelEdgeConfigStoresQuery, VercelEdgeConfigStoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VercelEdgeConfigStoresQuery, VercelEdgeConfigStoresQueryVariables>(VercelEdgeConfigStoresDocument, options);
      }
export function useVercelEdgeConfigStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VercelEdgeConfigStoresQuery, VercelEdgeConfigStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VercelEdgeConfigStoresQuery, VercelEdgeConfigStoresQueryVariables>(VercelEdgeConfigStoresDocument, options);
        }
export function useVercelEdgeConfigStoresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VercelEdgeConfigStoresQuery, VercelEdgeConfigStoresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VercelEdgeConfigStoresQuery, VercelEdgeConfigStoresQueryVariables>(VercelEdgeConfigStoresDocument, options);
        }
export type VercelEdgeConfigStoresQueryHookResult = ReturnType<typeof useVercelEdgeConfigStoresQuery>;
export type VercelEdgeConfigStoresLazyQueryHookResult = ReturnType<typeof useVercelEdgeConfigStoresLazyQuery>;
export type VercelEdgeConfigStoresSuspenseQueryHookResult = ReturnType<typeof useVercelEdgeConfigStoresSuspenseQuery>;
export type VercelEdgeConfigStoresQueryResult = Apollo.QueryResult<VercelEdgeConfigStoresQuery, VercelEdgeConfigStoresQueryVariables>;
export const VercelSsoDocument = gql`
    mutation VercelSso($input: VercelSsoInput!) {
  vercelSso(input: $input) {
    firebaseCustomToken
  }
}
    `;
export type VercelSsoMutationFn = Apollo.MutationFunction<VercelSsoMutation, VercelSsoMutationVariables>;

/**
 * __useVercelSsoMutation__
 *
 * To run a mutation, you first call `useVercelSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVercelSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vercelSsoMutation, { data, loading, error }] = useVercelSsoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVercelSsoMutation(baseOptions?: Apollo.MutationHookOptions<VercelSsoMutation, VercelSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VercelSsoMutation, VercelSsoMutationVariables>(VercelSsoDocument, options);
      }
export type VercelSsoMutationHookResult = ReturnType<typeof useVercelSsoMutation>;
export type VercelSsoMutationResult = Apollo.MutationResult<VercelSsoMutation>;
export type VercelSsoMutationOptions = Apollo.BaseMutationOptions<VercelSsoMutation, VercelSsoMutationVariables>;
export const VerifyEmailAndAcceptInviteDocument = gql`
    mutation VerifyEmailAndAcceptInvite($input: VerifyEmailAndAcceptInviteInput!) {
  verifyEmailAndAcceptInvite(input: $input) {
    verifiedEmail
    totalBusinessesCount
  }
}
    `;
export type VerifyEmailAndAcceptInviteMutationFn = Apollo.MutationFunction<VerifyEmailAndAcceptInviteMutation, VerifyEmailAndAcceptInviteMutationVariables>;

/**
 * __useVerifyEmailAndAcceptInviteMutation__
 *
 * To run a mutation, you first call `useVerifyEmailAndAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailAndAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailAndAcceptInviteMutation, { data, loading, error }] = useVerifyEmailAndAcceptInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailAndAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailAndAcceptInviteMutation, VerifyEmailAndAcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailAndAcceptInviteMutation, VerifyEmailAndAcceptInviteMutationVariables>(VerifyEmailAndAcceptInviteDocument, options);
      }
export type VerifyEmailAndAcceptInviteMutationHookResult = ReturnType<typeof useVerifyEmailAndAcceptInviteMutation>;
export type VerifyEmailAndAcceptInviteMutationResult = Apollo.MutationResult<VerifyEmailAndAcceptInviteMutation>;
export type VerifyEmailAndAcceptInviteMutationOptions = Apollo.BaseMutationOptions<VerifyEmailAndAcceptInviteMutation, VerifyEmailAndAcceptInviteMutationVariables>;